import SubtitleExportTrialPlaceholder from '@/shared/assets/images/subtitle-export-trial.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';

const TRIAL_PLAN_CONTENT: ModalContent = {
  title: 'Take your subtitles wherever the work happens',
  bulletsHeader: '',
  buttonText: 'See plans with Subtitle export',
  content: {
    allowedPlanNames: ['Creator Pro', 'Business'],
    chip: {
      title: 'Get subtitle export with other Pro tools',
    },
    perfectFor: {
      title: 'Perfect for',
      text: 'anyone who publishes across platforms or works with a team.',
    },
    selectedPlan: 'Creator Pro',
    whatYouCanDo: {
      title: 'With Subtitle export:',
      bullets: [
        'Publish to YouTube, TikTok, or any platform in minutes',
        'Hand off to editors or clients without extra steps',
        'Timestamps stay perfectly aligned with your video',
      ],
    },
  },
  features: [],
  media: {
    src: SubtitleExportTrialPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: () => MixpanelEvents.trialFeatureUpsellModalUnlockClick({ feature: 'subtitleExport' }),
  mixpanelOpeningEvent: () => MixpanelEvents.trialFeatureUpsellModalShown({ feature: 'subtitleExport' }),
  subtitle:
    'Export translated subtitles as an SRT file — already timed, already translated, ready to drop into any workflow.',
};

export const SUBTITLE_EXPORT_CONTENT: LimitedFeatureContent = {
  trial: TRIAL_PLAN_CONTENT,
};
